import React from "react";
import {CodPaymentMethodSelectionForm} from "components/layouts/customerLayout/components/codPaymentMethodSelectionForm/CodPaymentMethodSelectionForm";
import {StyledModal} from "./style/CodAggrementSelectionModal.styles";

export const CodAggrementSelectionModal = ({
    open,
    setOpen,
    recall,
    setRecall,
    canCodPaymentMethodSelectionSubcompanies
}) => {
    return (
        <StyledModal
            visible={open}
            onCancel={() => setOpen(false)}
            footer={null}
            width={window.innerWidth <= 768 ? "95%" : 1100}
            centered
            title="Ödeme Yöntemi Seçimi"
        >
            <CodPaymentMethodSelectionForm
                recallState={recall}
                recallFn={() => {
                    setRecall(!recall);
                    setOpen(false);
                }}
                paymentMethodsSelectionEnabledSubCompanies={
                    canCodPaymentMethodSelectionSubcompanies || []
                }
            />
        </StyledModal>
    );
};
